<template>
<div class="page-content-wrapper">
  <div class="page-content permission">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">功能权限定义</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->

    <div id="search-bar" class="lp-flex-box">
      <input type="text" name="name" placeholder="输入名称查询" class="form-control">
      <button type="button" class="btn blue" @click="query">查询<i class="m-icon-swapright m-icon-white"></i></button>
      <button type="button" class="btn green" @click="detail(0)">新增权限<i class="icon-plus m-icon-white"></i></button>
    </div>
    <br>

    <!-- BEGIN PERMISSION LIST -->
    <table class="table table-striped table-hover table-bordered table-condensed">
      <thead>
        <tr>
          <th width="20%" class="text_overflow">名称</th>
          <th class="text_overflow">定义</th>
          <th width="15%">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in biz.items">
          <td style="vertical-align:middle" class="text_overflow">{{item.name}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.permission}}</td>
          <td>
            <a href="javascript:void(0)" @click="detail(item.id)">详情</a>|
            <a href="javascript:void(0)" @click="remove(item.id)">删除</a>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- END PERMISSION LIST -->

  </div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import {mapState} from 'vuex'
import mixins from '../../mixins/index'
import common from '../../lib/methods/common.js'
import {MSG_ID, SER_RESP_CODE} from '../../lib/constant.js'
import PermissionEdit from './PermissionEdit.vue'
export default {
  name: 'permission',
  mixins: mixins,
  components: {
    PermissionEdit
  },
  data () {
    return {
      biz: {
        items: [],
        name: '',
        id: '',
        permission: '',
        groupId: 1,
        applicationId: 1
      },
      totalCount: 0,
      pageSize: 500
    }
  },
  created () {
    window.emitter.on(MSG_ID.MSG_PERMISSION_SET_SUCCESS, (...args) => {
      this.query()
    })
  },
  mounted () {
    this.query()
  },
  methods: {
    query () {
      let that = this
      let reqdata = {page_index: this.pager.pageIndex, page_size: this.pageSize, account: this.uid(), name: this.biz.name}
      http.invoke('auth.pagePermission', reqdata, function (data) {
        that.biz.items = data.content
        that.totalCount = data.total_count
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, PermissionEdit, {title: '新增/编辑权限', id: id})
    },
    remove (id) {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除权限后对应的角色将自动失去该权限，确定删除?', (data) => {
        let reqdata = {action: 2, account: this.uid(), id: id}
        http.invoke('auth.setPermission', reqdata, (data) => {
          window.emitter.emit(MSG_ID.MSG_UI_TIP_SUCC, '删除成功!')
          window.emitter.emit(MSG_ID.MSG_PERMISSION_SET_SUCCESS)
        }, (state) => {
          if (state.code !== 2000000) {
            window.emitter.emit(MSG_ID.MSG_UI_TIP_ERR, SER_RESP_CODE[state.code])
            return
          }
        })
      })
    },
    cancel () {
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.permission {
  background-color: #fff;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// Permission.vue?4bf795d8